import React from 'react';
import './Socialheadergal.css'; // Importe le CSS
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'; // Import de l'icône de flèche


function Socialheadergal() {
  return (
    <div className="header-containerga25">
        <div className="boutton-containerga25">
                <div className='butga25'>
                  
             <button className="bouttonga25">GALERIE<ArrowForwardIcon className="1arrow-icon" />SERVICE SOCIAL</button>
             <h1>SERVICE SOCIAL</h1> 
            </div>
            </div>
    </div>
  );
}

export default Socialheadergal;


